module.exports = __webpack_public_path__ + "img/BOTTOM.783d87e5.jpg";